import TranslationText from '@Components/Utilities/TranslationText';
import translator from '@Components/Utilities/Translator';
import TextField from '@Components/Shared/Controls/TextField';
import Modal from '@Components/Shared/Modals/Modal';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useState, useEffect } from 'react';
import { useSetRecoilState, useRecoilValue } from 'recoil';
import { sortDistanceWithEnteredLocation, runSortWithCurrentLocation } from '@Components/Utilities/DistanceSortHelper';
import { unsetScrollPosition } from '@Components/Utilities/SandhillsUtility';

const DistanceLocationModal = (props) => {

    const setCurrentUser = useSetRecoilState(atoms.currentUser);
    const [showDistanceError, setShowDistanceError] = useState(props.ShowDistanceSortError);
    const [userEnteredLocation, setUserEnteredLocation] = useState(props.CurrentUserFormattedAddress);
    const routes = useRecoilValue(atoms.routes);

    useEffect(function updateCurrentLocation() {
        if (props.DistanceSortIsSelected && props.CurrentUserFormattedAddress != userEnteredLocation) {
            setUserEnteredLocation(props.CurrentUserFormattedAddress);
        }
    }, [props.CurrentUserFormattedAddress]);

    const sortWithCurrentLocation = () => {
        runSortWithCurrentLocation(
            routes.FormattedLocationStringFromCurrentCoordinates,
            routes.AjaxGetCoordinatesFromLocationStringUrl,
            props.CurrentAuthenticatedUserLocationForCoordinates,
            routes.AjaxSetCurrentUserLocationCookie,
            routes.AjaxGetDecryptedCoordinatesFromCurrentLocationCookie,
            !props.DisplayShowClosestFirstByConsent
        ).then(location => {
            unsetScrollPosition();
            setShowDistanceError(false);
            props.OnUpdate({
                Latitude: location.latitude,
                Longitude: location.longitude,
                UseCurrentLocation: true
            });
            setCurrentUser(user => {
                return {
                    ...user,
                    CurrentLocation: {
                        ...user.CurrentLocation,
                        FormattedAddress: location.formattedAddress
                    }
                };
            });
        }).catch(() => {
            setShowDistanceError(true);
        });
    };

    const sortWithEnteredLocation = (e, enteredLocation) => {
        sortDistanceWithEnteredLocation(routes.AjaxGetCoordinatesFromLocationStringUrl, (enteredLocation || userEnteredLocation))
            .then(location => {
                unsetScrollPosition();
                setShowDistanceError(false);
                props.OnUpdate({
                    Latitude: location.latitude,
                    Longitude: location.longitude
                });
                setCurrentUser(user => {
                    return {
                        ...user,
                        CurrentLocation: {
                            ...user.CurrentLocation,
                            FormattedAddress: location.formattedAddress
                        }
                    };
                });
            })
            .catch(() => {
                setShowDistanceError(true);
            });
    };

    const getAutoCompleteCallback = () => {
        return (e, ui) => { sortWithEnteredLocation(e, ui.item.value); }
    };

    const getAutoCompleteUrl = (e) => {
        return routes.LocationAutosuggestUrl + encodeURI(e.target.value.trim());
    };

    const handleFieldChange = (e) => {
        setUserEnteredLocation(e.target.value);
    };

    return (
        <Modal containerClassName='distance-modal' onEscapeKeyClose={props.ToggleDistanceModal}>
            <Modal.Header onClose={props.ToggleDistanceModal} />
            <Modal.Body>
                <p id='description-label' className='hidden'>Enter your location.</p>

                {props.DisplayShowClosestFirstByConsent && 
                    <>
                        <div className='current-btn' onClick={sortWithCurrentLocation} role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') {e.preventDefault(); sortWithCurrentLocation(); } }}>                
                            <i className='fas fa-crosshairs' aria-hidden='true'></i><TranslationText tKey='sandhills.usemycurrentlocation' />
                        </div>
                        <div>
                            <p><TranslationText tKey='sandhills.thiswilluseyourgeolocation' /></p>
                        </div>
                        <strong><TranslationText tKey='sandhills.tradepubwebsite.mvc.or' /></strong>
                    </>
                }
                <div className='distance-form-container'>
                    <div className='distance-form'>
                        <TextField
                            name='sort-location-autosuggest'
                            value={userEnteredLocation}
                            type='text'
                            required={false}
                            id={'sort-location'}
                            onFieldChanged={handleFieldChange}
                            updateField={setUserEnteredLocation}
                            focus={false}
                            placeholder={translator.translate('sandhills.citystatezip')}
                            autoComplete={{
                                ajaxUrl: (e) => getAutoCompleteUrl(e),
                                callback: getAutoCompleteCallback()
                            }}
                            autoCompleteDelay='1'
                        />
                        <button className='ts-button' type='submit' id='sort-submit' onClick={sortWithEnteredLocation} aria-label={translator.translate('sandhills.tradepubwebsite.mvc.submit')}>
                            <i className='fas fa-chevron-right' aria-hidden='true'></i>
                        </button>
                    </div>
                    {showDistanceError &&
                        <div className='error'>
                            <p><TranslationText tKey='sandhills.wecouldnotretrieveyourlocation' /></p>
                        </div>
                    }
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default DistanceLocationModal;